import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Observable, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HospitalService } from '../../_services';


@Component({
  selector: 'app-book-offer',
  templateUrl: './book-offer.component.html',
  styleUrls: ['./book-offer.component.scss']
})
export class BookOfferComponent implements OnInit,OnDestroy {

  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  language: any;
  Offers$:any[]=[];
  AllOffers$:any[]=[];
  SectionId;
  OfferData;
  ClientName;
  Mobile;
  OfferId
  MobilePattern = new RegExp("(5)[0-9]{8}");
  AppId;
  constructor( private HospitalService: HospitalService,private route: ActivatedRoute, private router: Router,
    private translationService: TranslationService, private auth: AuthService, private toast: HotToastService) {
  }
  ngOnInit(): void {
    this.SectionId = this.route.snapshot.params['SectionId'];
    this.OfferId = this.route.snapshot.params['OfferId'];
    this.AppId = this.route.snapshot.params['AppId'];

    this.LoadAllOffers();
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.HospitalService.isLoading$;
    
  }
  
  LoadAllOffers() {
    const sb =  this.HospitalService.GetAllOffersBySectionId(this.SectionId).subscribe(res =>
      {
        this.Offers$ = res
        this.AllOffers$ = res
        if(this.OfferId)
          {
            this.OnChangeOffer(this.OfferId)
          }
      });
    this.subscriptions.push(sb);
  }
  OnSearchOffer(Offer) {
    let SearchTerm = Offer.term;
    this.Offers$ =this.AllOffers$.filter(x => x.nameEn.toLower().includes(SearchTerm.toLower()) || x.nameAr.includes(SearchTerm))
  }
 
  OnChangeOffer(OfferId)
  {
    if (OfferId?.target?.value)
    {
      this.OfferId = Number(OfferId.target.value)
    }
    this.OfferData = this.AllOffers$.find(x => x.id == this.OfferId);
  }

  onSubmit() {
    if (!this.OfferId || this.OfferId == null || this.OfferId == 0)
    {
      if (this.language == "ar") {
        this.toast.warning("<b>من فضلك اختر العرض اولا</b>", { style: { padding: '20px' } });
      }
      else {
        this.toast.warning("<b>Please choose the offer</b>", { style: { padding: '20px' } });
      }
      return;
    }
    if (!this.ClientName || this.ClientName.trim() == "")
      {
        if (this.language == "ar") {
          this.toast.warning("<b>من فضلك ادخل الاسم </b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Please enter the name</b>", { style: { padding: '20px' } });
        }
        return;
      }
      if (!this.Mobile || this.Mobile == "")
        {
          if (this.language == "ar") {
            this.toast.warning("<b>من فضلك ادخل رقم الجوال </b>", { style: { padding: '20px' } });
          }
          else {
            this.toast.warning("<b>Please enter the mobile No.</b>", { style: { padding: '20px' } });
          }
          return;
        }
        if (!this.MobilePattern.test(this.Mobile))
          {
            if (this.language == "ar") {
              this.toast.warning("<b>من فضلك ادخل رقم جوال صحيح </b>", { style: { padding: '20px' } });
            }
            else {
              this.toast.warning("<b>Please enter valid mobile No.</b>", { style: { padding: '20px' } });
            }
            return;
          }
    this.HospitalService.showLoader();
    var offerRequest = {
      ClientName : this.ClientName,
      ClientMobile : this.Mobile,
      ApiOfferImageId : this.OfferId,
      ApplicationId : this.AppId,
    }
    const Subscr = this.HospitalService.AddOfferRequest(offerRequest).pipe(
      catchError((errorMessage) => {
        this.HospitalService.hideLoader();
        return of(errorMessage);
      })
    ).subscribe(res => {
      if (res.isSuccess && res.responseCode == 200) { 
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.HospitalService.hideLoader();
        setTimeout(() => {
          this.router.navigate(['/offersandpackages' ])
        }, 1000);

      }
      else if (res.isSuccess && res.responseCode == 400) {
        this.toast.warning("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.HospitalService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.HospitalService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.HospitalService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.HospitalService.hideLoader();

      }
    });
    this.subscriptions.push(Subscr);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
